import { Link } from 'react-scroll';

const navLinks = [
  { label: 'Home', to: 'home' },
  { label: 'About', to: 'about' },
  { label: 'Skills', to: 'skill' },
  { label: 'Services', to: 'service' },
  { label: 'Projects', to: 'portfolio' },
  { label: 'Contact', to: 'contact' },
];

export default function Footer() {
  return (
    <footer style={{ background: 'var(--ink)', borderTop: '1px solid rgba(255,255,255,0.1)', padding: '72px 0 30px' }}>
      <div className="section-shell">
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '1.1fr 0.8fr 1fr', gap: 28, marginBottom: 46 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 }}>
              <span
                style={{
                  width: 42,
                  height: 42,
                  borderRadius: 8,
                  display: 'grid',
                  placeItems: 'center',
                  background: 'linear-gradient(135deg, var(--aqua), var(--rose), var(--sun))',
                  color: 'var(--ink)',
                  fontFamily: 'var(--font-display)',
                  fontWeight: 800,
                }}
              >
                P
              </span>
              <span style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 22 }}>
                Prakash.C
              </span>
            </div>
            <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.8, maxWidth: 340 }}>
              Colorful, responsive, premium web experiences built from Chennai for brands, founders, and small businesses.
            </p>
          </div>

          <div>
            <h4 style={{ color: 'var(--aqua)', fontFamily: 'var(--font-display)', fontSize: 12, fontWeight: 800, letterSpacing: 1.8, textTransform: 'uppercase', marginBottom: 18 }}>
              Quick links
            </h4>
            <div style={{ display: 'grid', gap: 10 }}>
              {navLinks.map(link => (
                <Link
                  key={link.to}
                  to={link.to}
                  href={`#${link.to}`}
                  spy
                  smooth
                  offset={-80}
                  duration={600}
                  style={{ color: 'var(--muted)', cursor: 'pointer', textDecoration: 'none', fontWeight: 700 }}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="premium-card" style={{ padding: 24, boxShadow: 'none' }}>
            <div className="color-line" style={{ marginBottom: 18 }} />
            <h4 style={{ fontFamily: 'var(--font-display)', fontSize: 20, lineHeight: 1.2, marginBottom: 12 }}>
              Open for web projects
            </h4>
            <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 18 }}>
              Websites, redesigns, dashboards, landing pages, and brand portfolio pages.
            </p>
            <a href="mailto:prakash12991299@gmail.com" className="btn-secondary" style={{ minHeight: 42, padding: '9px 16px' }}>
              Email Me
            </a>
          </div>
        </div>

        <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: 22, display: 'flex', justifyContent: 'space-between', gap: 14, flexWrap: 'wrap' }}>
          <p style={{ color: 'var(--muted)', fontSize: 13 }}>
            Copyright 2026 Prakash.C. All rights reserved.
          </p>
          <a href="https://prakash1210.site" style={{ color: 'var(--white)', textDecoration: 'none', fontSize: 13, fontWeight: 700 }}>
            prakash1210.site
          </a>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}
